import { Route } from '@angular/router';
import { CanDeactivateGuard } from '@pkp-g/core';

export const objectManagementRoutes: Route[] = [
  {
    path: '',
    redirectTo: 'parkings',
    pathMatch: 'full',
  },
  {
    path: 'parkings',
    loadComponent: () => import('./pages').then(p => p.ParkingListPage),
    title: 'UIMS - Parkings',
  },
  {
    path: 'parkings/create',
    loadComponent: () => import('./pages').then(p => p.ParkingCreatePage),
    title: 'UIMS - Parking Create',
  },
  {
    path: 'parkings/:id',
    loadComponent: () => import('./pages').then(p => p.ParkingsDetailsComponent),
    title: 'UIMS - Parking Details',
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: 'gates',
    loadComponent: () => import('./pages').then(p => p.GateListPage),
    title: 'UIMS - Gates',
  },
  {
    path: 'gates/create',
    loadComponent: () => import('./pages').then(p => p.GatesCreatePage),
    title: 'UIMS - Gates Create',
  },
  {
    path: 'gates/:id',
    loadComponent: () => import('./pages').then(p => p.GatesDetailsComponent),
    title: 'UIMS - Gates Details',
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: 'cameras',
    loadComponent: () => import('./pages').then(p => p.CameraListPage),
    title: 'UIMS - Cameras',
  },
  {
    path: 'cameras/create',
    loadComponent: () => import('./pages').then(p => p.CameraCreateComponent),
    title: 'UIMS - Camera Create',
  },
  {
    path: 'cameras/:id',
    loadComponent: () => import('./pages').then(p => p.CameraDetailsComponent),
    title: 'UIMS - Camera Details',
    canDeactivate: [CanDeactivateGuard],
  },
];
